import { css, html, htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";
import { MapService } from "../services/MapService";

const styles: string = css`
body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    margin: 0;
    background-color: #000000;
    position: relative;
}

div {
    position: relative;
    width: 100%;
}

#back-to-home {
    position: fixed;
    top: 10px;
    left: 10px;
}

#back-to-home img {
    width: 200px; /* Adjust size as needed */
    height: auto;
    transition: transform 0.2s ease-in-out;
}

#back-to-home img:hover {
    transform: scale(1.1);
    opacity: 0.8;
}

.map {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
}

.map h1 {
    font-family: "Onesize";
    position: absolute;
    top: 20px;
    text-align: center;
    width: 100%;
    font-size: 24px;
}

.map img {
    max-width: 80%;
    height: auto;
    margin-top: 60px; /* Adjust to avoid overlapping with heading */
}`;

export class MapComponent extends HTMLElement {
    private readonly _gameEventService: GameEventService = new GameEventService();
    private readonly _MapService: MapService = new MapService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        this.render();
    }

    /**
     * Update the canvas to the provided game state
     *
     * @param state Game state to update the canvas to
     */

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        // Create a placeholder for the title
        const titlePlaceholder: HTMLDivElement = document.createElement("div");
        titlePlaceholder.innerHTML = "<h1>Loading...</h1>";

        const element: HTMLElement[] = htmlArray`
        <style>
            ${styles}
        </style>
    
        ${titlePlaceholder}  <!-- Placeholder for title -->
        ${this.backToGame()}
        `;

        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(...element);

        // Fetch the title asynchronously and update the placeholder
        this.renderTitle().then(titleHTML => {
            titlePlaceholder.innerHTML = titleHTML;
        }).catch((error: unknown) => {
            console.error("Error rendering title:", error);
            titlePlaceholder.innerHTML = "<h1>Error loading title</h1>";
        });
    }

    private async renderTitle(): Promise<string> {
        return this._MapService.getCurrentRoom().then((gameState: string) => {
            console.log(gameState);
            console.log("Type of gameState:", typeof gameState);
            console.log("Value of gameState:", JSON.stringify(gameState));

            if (gameState === "cijferslotkamer") {
                return `
                <div class="map">
                    <h1>You are now in the ${gameState}</h1>
                    <img src="/assets/img/Rooms_map/NumberLockRoom.png">
                </div>`;
            }
            else if (gameState === "eindkamer") {
                return `
                <div class="map">
                    <h1>You are now in the ${gameState}</h1>
                    <img src="/assets/img/Rooms_map/EndRoom.png">
                </div>`;
            }
            else if (gameState === "Doorroom") {
                return `
                <div class="map">
                    <h1>You are now in the ${gameState}</h1>
                    <img src="/assets/img/Rooms_map/doorRoom.png">
                </div>`;
            }
            else if (gameState === "cliffroom") {
                return `
                <div class="map">
                    <h1>You are now in the ${gameState}</h1>
                    <img src="/assets/img/Rooms_map/cliffRoom.png">
                </div>`;
            }
            else if (gameState === "lobbyroom") {
                return `
                <div class="map">
                    <h1>You are now in the ${gameState}</h1>
                    <img src="/assets/img/Rooms_map/lobbyRoom.png">
                </div>`;
            }
            else if (gameState === "Paintingroom1") {
                return `
                <div class="map">
                    <h1>You are now in the ${gameState}</h1>
                    <img src="/assets/img/Rooms_map/paintingRoom1.png">
                </div>`;
            }
            else if (gameState === "Paintingroom2") {
                return `
                <div class="map">
                    <h1>You are now in the ${gameState}</h1>
                    <img src="/assets/img/Rooms_map/paintingRoom2.png">
                </div>`;
            }
            else if (gameState === "Ghostroom") {
                return `
                <div class="map">
                    <h1>You are now in the ${gameState}</h1>
                    <img src="/assets/img/Rooms_map/ghostRoom.png">
                </div>`;
            }
            else {
                return "<h1>Error</h1>";
            }
        }).catch((error: unknown) => {
            console.error("Error fetching game state:", error);
            return "<h1>Error loading room data</h1>";
        });
    }

    private backToGame(): HTMLElement {
        const element: HTMLElement = html`
                <div>
                    <p><a href="#" id="back-to-home"><img src="/assets/img/icon/red_cross.png"></a></p>
                </div>
            `;
        element.querySelector("#back-to-home")?.addEventListener("click", () => this._gameEventService.switchPage(Page.Canvas));

        return element;
    }
}
